import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TreatmentDetail from "./pages/TreatmentDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="behandlinger/:id" element={<TreatmentDetail />} />
          <Route path="om-pernille" element={<About />} />
          <Route path="kontakt" element={<Contact />} />
          <Route path="samtykke-og-privatliv" element={<PrivacyPolicy />} />
          <Route path="handelsbetingelser" element={<Terms />} />
        </Route>
      </Routes>
    </Router>
  );
}
